import React from "react";

export default function PaginationComponent({
  pageNumber,
  totalPages,
  hasNextPage,
  hasPreviousPage,
  onPageChange,
  scrollToTop = true,
}) {
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
    scrollToTop && window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPageNumbers = () => {
    const pages = [];
    const pageRange = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pageRange.push(i);
    } else {
      if (pageNumber <= 4) {
        pageRange.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (pageNumber >= totalPages - 3) {
        pageRange.push(
          1,
          "...",
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        );
      } else {
        pageRange.push(
          1,
          "...",
          pageNumber - 1,
          pageNumber,
          pageNumber + 1,
          "...",
          totalPages,
        );
      }
    }

    pageRange.forEach((p, i) => {
      if (p === "...") {
        pages.push(
          <li key={`ellipsis-${i}`} className="px-2 text-muted">
            ...
          </li>,
        );
      } else {
        const isActive = p === pageNumber;
        pages.push(
          <li key={p}>
            <button
              onClick={() => handlePageChange(p)}
              className="border rounded d-flex align-items-center justify-content-center"
              style={{
                width: "40px",
                height: "40px",
                margin: "4px",
                backgroundColor: isActive ? "#212529" : "#fff",
                color: isActive ? "#fff" : "#000",
                borderColor: "#ddd",
                transition: "all 0.2s ease-in-out",
              }}
            >
              {p}
            </button>
          </li>,
        );
      }
    });

    return pages;
  };

  return (
    <nav aria-label="Pagination" className="mt-5">
      <ul
        className="d-flex flex-wrap flex-md-nowrap justify-content-center align-items-center list-unstyled mb-0"
        style={{
          gap: "4px",
          rowGap: "8px",
        }}
      >
        <li>
          <button
            onClick={() => handlePageChange(pageNumber - 1)}
            disabled={!hasPreviousPage}
            className="border rounded d-flex align-items-center justify-content-center"
            style={{
              width: "40px",
              height: "40px",
              margin: "4px",
              backgroundColor: "#fff",
              color: "#000",
              borderColor: "#ddd",
              opacity: hasPreviousPage ? 1 : 0.4,
            }}
          >
            &lt;
          </button>
        </li>
        {renderPageNumbers()}
        <li>
          <button
            onClick={() => handlePageChange(pageNumber + 1)}
            disabled={!hasNextPage}
            className="border rounded d-flex align-items-center justify-content-center"
            style={{
              width: "40px",
              height: "40px",
              margin: "4px",
              backgroundColor: "#fff",
              color: "#000",
              borderColor: "#ddd",
              opacity: hasNextPage ? 1 : 0.4,
            }}
          >
            &gt;
          </button>
        </li>
      </ul>
    </nav>
  );
}
